import ErrorLabel from 'ui/atoms/ErrorLabel'
import Toggle from 'ui/atoms/Toggle'
import Tabs from 'ui/molecules/Tabs'

import ButtonClear from './ButtonClear'
import { ButtonIcon } from './ButtonIcon'
import ButtonIconClose from './ButtonIconClose'
import ButtonListVertical from './ButtonListVertical'
import Checkbox from './Checkbox'
import { DataTip } from './DataTip'
import Dropdown from './Dropdown'
import { FileInput } from './FileInput'
import Footer from './Footer'
import Icons from './Icons'
import { ImageMarker } from './ImageMarker'
import MessageBar from './MessageBar'
import ModalDialog from './ModalDialog'
import NumericText from './NumericText'
import PasswordInput from './PasswordInput'
import PrimaryButton from './PrimaryButton'
import QuestionLabel from './QuestionLabel'
import Radio from './Radio'
import { SearchBar } from './SearchBar'
import Select from './Select'
import SelectGroup from './SelectGroup'
import Signature from './Signature'
import SingleLinePhone from './SingleLinePhone'
import StripeCard from './StripeCard'
import TableItem from './TableItem'
import TableTitle from './TableTitle'
import Text from './Text'
import Theme from './theme'
import Wizard from './Wizard'

const Ui = {
  ButtonClear,
  ButtonIcon,
  ButtonIconClose,
  ButtonListVertical,
  Checkbox,
  DataTip,
  Dropdown,
  ErrorLabel,
  FileInput,
  Footer,
  ImageMarker,
  MessageBar,
  ModalDialog,
  NumericText,
  PasswordInput,
  PrimaryButton,
  QuestionLabel,
  Radio,
  SearchBar,
  Select,
  SelectGroup,
  Signature,
  SingleLinePhone,
  StripeCard,
  TableItem,
  TableTitle,
  Tabs,
  Theme,
  Toggle,
  Wizard,
  ...Icons,
  ...Text,
}

export default Ui
